/**
 * Multimedia File Feature
 * Orquesta almacenamiento, carga y adaptadores de archivos por contexto.
 */

export * from './adapters/rc-multimedia-file.adapter';
export * from './models/multimedia-file-api.models';
export * from './services/multimedia-file-storage.service';
export * from './services/multimedia-file-uploader.service';
